import {
    BlockWrapper,
    defineBlock,
    smartProps,
    useBlockEffect,
    useInspectorControl,
    useSmartProp,
} from '@smartfire/js-block-engine';
import style from './block.module.scss';
import { useState, useRef, lazy } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import TileEvent from '../archive-agenda/TileEvent';
import 'swiper/css';
import 'swiper/css/pagination';
import { EditableHeading } from '@smartfire/components';
import { useMediaQuery } from 'react-responsive';
import { Button } from '../button/block';
import Sun from '../components/sun';

const Inspector = lazy(() => import('./inspector.js'));

const HomeAgenda = ({ archiveLink = null, anchorId = '' }) => {
    useInspectorControl(Inspector);

    const isTablet = useMediaQuery({ query: '(max-width: ' + style.tabletBreakpoint + ')' });
    const isMobile = useMediaQuery({ query: '(max-width: ' + style.mobileBreakpoint + ')' });

    const [postsList] = useSmartProp('postsList');
    const [current, setCurrentIndex] = useState(0);
    const [isEnd, setIsEnd] = useState(false);
    const [height, setHeight] = useState(0);

    const swiperRef = useRef(null);
    const bulletsRef = useRef(null);

    useBlockEffect(() => {
        setTimeout(() => {
            setHeight(document.getElementById('swiper').clientHeight);
        }, 500);
    }, [postsList]);

    const swiperSettings = {
        slidesPerView: isTablet ? (isMobile ? 1 : 2) : 3,
        spaceBetween: 24,
        autoplay: {
            delay: 5000,
            speed: 800,
            disableOnInteraction: false,
        },
        pagination: {
            el: bulletsRef.current,
            clickable: true,
        },
        modules: [Autoplay, Pagination],
        className: style.swiper,
    };
    const heights = [270, 420, 254, 210, 200];
    const marginsTop = [40, 0, 60, 45, 60];

    const tileHeight = (i) => {
        let x = i - current;
        if (x < 0) x = postsList.length + x;
        return heights[x];
    };

    const tileMarginTop = (i) => {
        let x = i - current;
        if (x < 0) x = postsList.length + x;
        return marginsTop[x];
    };
    const handleRealIndexChange = (e) => {
        setCurrentIndex(e.activeIndex);
        setIsEnd(e.isEnd);
    };

    const swipe = (next) => {
        if (next === 1) swiperRef?.current?.swiper.slideNext();
        else swiperRef?.current?.swiper.slidePrev();
    };

    const swipeTo = (i) => {
        swiperRef?.current?.swiper.slideTo(i);
    };
    return (
        <BlockWrapper.Div id={'anchor-' + anchorId} className={style.block}>
            <Sun />
            <div className={style.top}>
                <p className={style.goldTitle}>Agenda</p>
                <div className={style.titleLink}>
                    <EditableHeading smartProp={'title'} />

                    {!isTablet && archiveLink && (
                        <Button
                            tagName="a"
                            text={'Tout l’agenda'}
                            color={style.white}
                            color2={style.yellow}
                            link={archiveLink}
                            arrow={'rightArrow'}
                            showInspector={false}
                        />
                    )}
                </div>
            </div>
            <div className={style.overflowHidden}>
                <Swiper
                    {...swiperSettings}
                    ref={swiperRef}
                    onRealIndexChange={handleRealIndexChange}
                    className={style.slider}
                    style={height ? { height: height + 'px' } : {}}
                    id="swiper"
                >
                    {postsList &&
                        postsList.map((post, i) => (
                            <SwiperSlide key={i}>
                                <TileEvent
                                    key={i}
                                    picture={post?.thumbnail?.url ?? false}
                                    alt={post?.thumbnail?.alt ?? 'Image mis en avant'}
                                    link={post.link}
                                    gmapLink={post.gmap_link}
                                    title={post.post_title}
                                    excerpt={post.post_excerpt}
                                    dates={post.dates}
                                    place={post.place}
                                    imageHeight={tileHeight(i)}
                                    marginTop={tileMarginTop(i)}
                                    i={i}
                                />
                            </SwiperSlide>
                        ))}
                </Swiper>
            </div>
            <div className={style.bottom}>
                <div className={style.navigation}>
                    <div ref={bulletsRef} className={style.swiperPagination} />

                    {!isTablet && postsList?.length > 3 && (
                        <Button
                            className={style.button}
                            tagName="a"
                            text={isEnd ? 'Retour' : 'Suivant'}
                            color={style.white}
                            color2={style.yellow}
                            type={'borders'}
                            shape={'rounded'}
                            arrow={isEnd ? 'leftArrow' : 'rightArrow'}
                            onClick={isEnd ? () => swipeTo(0) : () => swipe(isEnd ? -1 : 1)}
                            showInspector={false}
                        />
                    )}
                </div>

                {isTablet && archiveLink && (
                    <Button
                        tagName="a"
                        text={'Tout l’agenda'}
                        color={style.white}
                        color2={style.yellow}
                        link={archiveLink}
                        arrow={'rightArrow'}
                        showInspector={false}
                        className={style.archiveLinkMobile}
                    />
                )}
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: HomeAgenda,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 1,
            content: '',
        }),
        anchorId: smartProps.string.withDefault('agenda'),
        selectedPosts: smartProps.array.withDefault([]),
        postsList: smartProps.array.withDefault([]).contentServerSide(),
    },
    setup: {
        title: 'Home Agenda',
    },
});
